import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca0aba5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { for: "valorPadrao" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Nenhum", -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "erro"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _hoisted_1, [
      _createTextVNode(" Valor Padrão "),
      _withDirectives(_createElementVNode("select", {
        id: "valorPadrao",
        name: "valorPadrao",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.esteSelecionado) = $event)),
        required: ""
      }, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itensOrdenados, (opcao) => {
          return (_openBlock(), _createElementBlock("option", {
            key: opcao.getId().toString(),
            value: opcao.getId().toString()
          }, _toDisplayString(opcao.getTitulo().toString()), 9, _hoisted_3))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.esteSelecionado]
      ])
    ]),
    (_ctx.erro)
      ? (_openBlock(), _createElementBlock("article", _hoisted_4, _toDisplayString(_ctx.erro), 1))
      : _createCommentVNode("", true)
  ], 64))
}